export default __webpack_public_path__ + "static/media/celo.2cc3ce92.svg";